import React from 'react';
import { FileTextIcon, PrinterIcon, SmartphoneIcon, VideoOffIcon } from 'lucide-react';
const items = [{
  icon: FileTextIcon,
  title: '100% PDF',
  description: 'Six high-resolution PDF files. That’s the whole product.'
}, {
  icon: VideoOffIcon,
  title: 'No video, no audio',
  description: 'Nothing to sit through. Open the page you need and coach.'
}, {
  icon: PrinterIcon,
  title: 'Print-ready',
  description: 'Cards, plans, and trackers built to print at home in A4 or Letter.'
}, {
  icon: SmartphoneIcon,
  title: 'Any device, forever',
  description: 'Phone, tablet, or laptop. Download once, keep it for life.'
}];
export function FormatStrip() {
  return <section className="w-full bg-carbon-800 py-12" aria-label="Product format" data-id="element-111" data-mp="1jem7ibq1uvve">
      <div className="mx-auto grid max-w-content grid-cols-1 gap-6 px-4 sm:grid-cols-2 sm:gap-8 sm:px-6 lg:grid-cols-4" data-id="element-112" data-mp="27582b1b1mjng">
        {items.map(item => {
        const Icon = item.icon;
        return <div key={item.title} className="flex items-start gap-4" data-id="element-113" data-mp="3ob3dpibp5m4q">
              <Icon className="mt-0.5 h-6 w-6 shrink-0 text-mint-deep" aria-hidden="true" data-id="element-114" data-mp="3k8q9iycllwa2" />
              <div data-id="element-115" data-mp="1uh2ahn5jdk1">
                <h2 className="font-display text-base uppercase tracking-wide text-paper" data-id="element-116" data-mp="1uqqq0sjtcnm">
                  {item.title}
                </h2>
                <p className="mt-1 text-sm leading-relaxed text-paper-dim" data-id="element-117" data-mp="3t7tts5ni4hq5">{item.description}</p>
              </div>
            </div>;
      })}
      </div>
    </section>;
}